import { FC } from "react";

const Quotes: FC = () => {
    return (
        <section className="w-full px-4 py-20 bg-black">
            <h2 className="text-lg md:text-3xl text-white text-center uppercase tracking-[10px] md:tracking-[12px]">
                The future is here{" "}
                <strong className="font-bold">today</strong>
            </h2>
        </section>
    );
};

export default Quotes;
